

module.exports = __webpack_require__.stylable.create(
    "editorapp2106538067",
    {"classes":{"root":"editorapp2106538067__root"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "editorapp2106538067",
    null
);
